<template>
  <div class="personalReportList">
    <div class="title">
      <div class="mainTitle">
        查验记录
        <!-- <span class="guide" @click="dialogGuide = true"
          ><i class="ico_guide">?</i>新手引导</span
        > -->
      </div>
      <Back/>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      fit
      highlight-current-row
      empty-text=" "
    >
      <el-table-column label="时间" width="110px" align="center">
        <template slot-scope="scope">
          <span>{{
            scope.row.createDate | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="被查验人" min-width="100px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column label="手机号" min-width="100px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column label="授权状态" min-width="100px" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 'WAIT'" style="color:#FF2A00">{{
            scope.row.status | statusFilter
          }}</span>
          <span v-else>{{ scope.row.status | statusFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160px" align="center">
        <template slot-scope="scope">
          <span
            class="detail"
            v-if="scope.row.status === 'AGREE'"
            @click="handleCheckReport(scope.row.id)"
            >查看报告</span
          >
          <!-- AGREE_TIME_OUT -->
          <span v-else>
            
          </span>
        </template>
      </el-table-column>
      <el-table-column label="交流互动" width="160px" align="center">
        <template slot-scope="scope">
          <div style="display:flex;flex-direction: column;">
            <span class="detail" @click="commingSoon">发送联系方式</span>
            <span class="detail" @click="commingSoon">发留言</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <no-data top="-260px" v-if="list.length === 0" />
    <CommingSoon ref="commingSoon" />
    <Cover
      :dialogGuide="dialogGuide"
      @dialogGuideClose="handleDialogGuideClose"
    >
      <ul slot="content">
        <li>
          <div>生成个人信息报告：</div>
          <div>
            您可以从数据档案中勾选必要信息生成个人信息报告，通过电子证书授权他人查看。
          </div>
        </li>
        <li>
          <div>生成电子证书：</div>
          <div>每份报告可生成多个电子证书，授权可查看时间段、可查看次数。</div>
        </li>
        <li>
          <div>下载电子证书：</div>
          <div>
            生成的电子证书可通过下载保存证书或者微信直接分享给他人。
          </div>
        </li>
      </ul>
    </Cover>
  </div>
</template>

<script>
import Cover from "@/components/Cover.vue";
import { inspectionRecord } from "@/api/inspection";
import NoData from "../../../components/NoData.vue";
import CommingSoon from "../../../components/CommingSoon.vue";
import Back from '../../../components/Back.vue';
export default {
  components: { Cover, NoData, CommingSoon, Back },
  filters: {
    statusFilter(status) {
      const statusMap = {
        WAIT: "待授权",
        AGREE: "已同意",
        REFUSE: "已拒绝",
        AGREE_TIME_OUT: "已失效"
      };
      return statusMap[status];
    }
  },
  data() {
    return {
      list: [],
      dialogGuide: false,
      listLoading: false,
      listQuery: {
        size: 100,
        pages: 1
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      inspectionRecord(this.listQuery).then(res => {
        this.list = res.data.d.records;
      });
    },
    handleDialogGuideClose() {
      this.dialogGuide = !this.dialogGuide;
    },
    handleCredentials() {
      this.$router.push("credentialsList");
    },
    handleCheckReport(id) {
      this.$router.push({
        path: "/reportPreview",
        query: { id, type: 2, active: 2 }
      });
      // type:0预览，1自看报告，查看他人报告2
      // active:1 证书，2报告
    },
    commingSoon() {
      this.$refs.commingSoon.handleShow();
    }
  }
};
</script>

<style lang="scss" scoped>
.personalReportList {
  display: flex;
  margin-top: 39px;
  flex: 1;
  margin-bottom: 70px;
  background: #fff;
  margin-left: 17px;
  padding: 38px 41px 60px 40px;
  flex-direction: column;
  min-height: 702px;
  box-sizing: border-box;
  .el-table th.el-table__cell {
    background-color: #f0f2f5;
  }
  .el-table {
    color: #6e6e6e;
  }
  .title {
    margin-bottom: 22px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    .mainTitle {
      color: #393939;
      display: flex;
      align-items: center;
      &::before {
        content: "";
        border-left: 3px solid #3a61b1;
        padding-right: 10px;
        height: 16px;
        position: relative;
        top: 0px;
      }
      .guide {
        font-size: 14px;
        font-weight: normal;
        color: #6e6e6e;
        display: flex;
        align-items: center;
        .ico_guide {
          background: #ff8d65;
          width: 15px;
          height: 15px;
          display: inline-block;
          border-radius: 15px;
          margin-right: 5px;
          margin-left: 12px;
          font-style: normal;
          text-align: center;
          color: #fff;
          font-size: 12px;
        }
      }
    }
  }
  .detail {
    color: #338ff7;
    cursor: pointer;
  }
  .btn_default {
    width: 165px;
    height: 39px;
    border: 1px solid #ddd;
    border-radius: 19.5px;
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/checkOthers/records.vue